import _ from 'underscore';

import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { IViewUsageInfo } from '~src/spacesPlatform/models/IUsageInfo';
import { IIdItem } from '~src/spacesPlatform/models/resourceParts';
import { UserMapper } from '~src/userManagement/users/models/mappers/UserMapper';
import { ViewMapper } from '~src/views/mappers/ViewMapper';
import { WorkbookMapper } from '~src/workbook/models/mappers/WorkbookMapper';

import { IGetBroadcastsResult } from './requests/GetBroadcastViewsRequest';
import { IBroadcast } from './types/IBroadcast';

export module BroadcastServerApiHelper {

    export function broadcastItems(broadcastsResult: IGetBroadcastsResult): IContentInfo[] {
        if (broadcastsResult?.broadcasts?.length > 0) {
            const users = index(UserMapper.map(broadcastsResult.users));
            const workbooks = index(WorkbookMapper.mapParents(broadcastsResult.workbooks, users));
            const views = index(ViewMapper.map(broadcastsResult.views, workbooks, <IViewUsageInfo> {}, favorites(broadcastsResult.viewFavorites)));
            const broadcasts = broadcastsResult.broadcasts.map((broadcastView: IBroadcast)=> {
                // TODO: need to handle the case of a view deleted on TOL
                return {...views[broadcastView.viewId], broadcast: true};
            });
            return broadcasts;
        }
        return [];
    }

    function index<T extends IIdItem>(items: ReadonlyArray<T>): _.Dictionary<T> {
        return _.indexBy(items, 'id');
    }

    function favorites(ids: string[]) {
        return _.indexBy(ids, _.identity);
      }
}